import { extends as _extends, objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { mergeRefs } from '@costar-ui/utils';
import React__default, { forwardRef } from 'react';
import useTextEllipsisState from '../../hooks/use-text-ellipsis-state.esm.js';
import useTextStyles from '../../hooks/use-text-styles.esm.js';

var _excluded = ["anchorClassName", "as", "children", "className", "color", "ellipsis", "fontFamily", "leading", "showBullet", "size", "testId", "title", "tracking", "variant", "weight", "shouldShowHoverTitle"];
// import { usePropId } from '../../utils/use-prop-id'

/**
/* PrivateText is for internal consumption within the package, it is typed with a union typing to server Text and Header component.
/* This allow for specific variant to be scope as Text and Header for the consumer.
 */
var PrivateText = /*#__PURE__*/forwardRef(function PrivateText(props, ref) {
  var _props$anchorClassNam = props.anchorClassName,
    anchorClassName = _props$anchorClassNam === void 0 ? 'csg-tw-text' : _props$anchorClassNam,
    _as = props.as,
    children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    color = props.color,
    ellipsis = props.ellipsis,
    fontFamily = props.fontFamily,
    leading = props.leading,
    showBullet = props.showBullet,
    size = props.size,
    testId = props.testId,
    _title = props.title,
    tracking = props.tracking,
    variant = props.variant,
    weight = props.weight,
    _props$shouldShowHove = props.shouldShowHoverTitle,
    shouldShowHoverTitle = _props$shouldShowHove === void 0 ? true : _props$shouldShowHove,
    rest = _objectWithoutProperties(props, _excluded);
  var Component = _as !== null && _as !== void 0 ? _as : 'span';
  var _useTextEllipsisState = useTextEllipsisState(ellipsis, children, _title, shouldShowHoverTitle),
    localRef = _useTextEllipsisState.localRef,
    showTitle = _useTextEllipsisState.showTitle,
    title = _useTextEllipsisState.title,
    handleOnMouseOver = _useTextEllipsisState.handleOnMouseOver;
  var classes = useTextStyles({
    className: className,
    color: color,
    ellipsis: ellipsis,
    fontFamily: fontFamily,
    leading: leading,
    size: size,
    tracking: tracking,
    variant: variant,
    weight: weight,
    showBullet: showBullet
  });

  // const id = usePropId(props.id)

  return /*#__PURE__*/React__default.createElement(Component
  // id={id}
  // @ts-ignore
  , _extends({
    ref: mergeRefs(ref, localRef),
    className: "".concat(anchorClassName, " ").concat(classes),
    testid: testId,
    title: showTitle ? title !== null && title !== void 0 ? title : '' : '',
    onMouseOver: handleOnMouseOver
  }, rest), children);
});
var Text = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(PrivateText, _extends({
    ref: ref
  }, props));
});
Text.displayName = 'Text';
var Text$1 = Text;

export { PrivateText, Text$1 as default };
//# sourceMappingURL=text.esm.js.map
